import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import SearchBox from "./SearchBox";
import SKELE from "./SKELE";
import useSkelephunks from "./hooks/useSkelephunks";

export default function Token() {
    const { tokenID } = useParams();
    return (<div className="landing" data-w-id="31a62934-7dee-bf92-5793-1bf374967db7">
        <Header subtitle="The Collection" />
        <div id="inventory" className="inventory wf-section">
            <div className="list">
                <SKELE tokenID={tokenID} />
                <SearchBox />
            </div>
            <div className="cta-info eth">reveal random new skelephunks</div>
            <div className="top">
                <Link to={'/'} className="cta">MINT MORE NOW</Link>
            </div>
        </div>

    </div>
    )
}
